import React from 'react';
import "../styles/Spinner.css";

const Spinner = ({ loading }) => {
    return loading ? <div className="spinner"></div> : null;
};

export default Spinner;